import { render, staticRenderFns } from "./surface-post-reaction-vote-new.vue?vue&type=template&id=e70fdbea&"
import script from "./surface-post-reaction-vote-new.vue?vue&type=script&lang=ts&"
export * from "./surface-post-reaction-vote-new.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports